const FILTERS = {
  "sdsb-certified-configurations": {
    "self_certification_tool_version": {
      title: "Self Certification Tool Version",
      icon: "server.png",
    },
    "certification_id": {
      title: "Certification ID",
      icon: "server.png",
    },
    "sds_version": {
      title: "SDS Version",
      icon: "server.png",
    },
    "storage": {
      title: "Storage",
      icon: "server.png",
    },
    "sds_version": {
      title: "SDS Version",
      icon: "server.png",
    },
    "partner": {
      title: "Partner",
      icon: "server.png",
    },
    "server_model": {
      title: "Server Model",
      icon: "server.png",
  },
  "management_nic": {
    title: "Management NIC",
    icon: "server.png",
},
"internode_nic": {
    title: "Internode NIC",
    icon: "server.png",
},
"fc_hba_or_compute_nic": {
    title: "FC HBA or Compute NIC",
    icon: "server.png",
  },
  "user_drive": {
    title: "User Drive",
    icon: "server.png",
},
"compute_sw": {
    title: "Compute SW",
    icon: "server.png",
},
"inter_node_sw": {
    title: "Inter-node SW",
    icon: "server.png",
},
"bios_bmc": {
    title: "BIOS/BMC",
    icon: "server.png",
}
  }

};
export default FILTERS;
